import { z } from "zod";

export const formSchema = z.object({
  full_name: z.string().min(2, "Name must be at least 2 characters"),
  primary_focus: z.array(z.string()).min(1, "Select at least one focus area"),
  other_focus: z.string().optional(),
  discovery_source: z.string(),
  other_discovery: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;

export const focusOptions = [
  { id: "crypto", label: "Crypto" },
  { id: "stocks", label: "Stocks" },
  { id: "forex", label: "Forex" },
  { id: "commodities", label: "Commodities" },
  { id: "other", label: "Other" },
];

export const discoveryOptions = [
  { id: "search", label: "Search engine (e.g., Google, Bing)" },
  { id: "twitter", label: "X/Twitter" },
  { id: "youtube", label: "YouTube" },
  { id: "ad", label: "Online advertisement" },
  { id: "referral", label: "Word of mouth/referral" },
  { id: "forum", label: "Trading forum or community" },
  { id: "blog", label: "Blog post or article" },
  { id: "other", label: "Other" },
];